<template>
  <v-container>
    <v-row>
      <v-col class="mb-4 mb-md-0 order-2 order-md-1 pt-4 pt-md-0">
        <v-card class="mb-5 mt-3">
          <div
            class="d-flex justify-center py-10 px-10"
            data-aos="fade-in"
          >
            <v-divider />
            <p class="text-center text-greeting text-5xl">
              Olá,
            </p>
          </div>
          <div style="margin-left:40px; margin-right: 40px;">
            <p
              class="text-xxl text-center font-weight-bold text-uppercase"
              data-aos="fade-in"
            >
              {{ authUser.name }}!
            </p>
          </div>
          <p
            class="text-center text-5xl"
            data-aos="slide-right"
            data-aos-duration="500"
          >
            Tudo bem com você?
          </p>
          <v-container class="position-relative px-16 z-i-0">
            <v-row
              data-aos="fade-right"
            >
              <v-col :md="10">
                <div class="text-3xl border rounded-xl p-5 my-10 border-default bg-white">
                  Com base no seu desempenho nos últimos simulados evo | enem, preparamos um <span class="font-weight-bold">material de estudos personalizado</span> para você.
                </div>
              </v-col>
            </v-row>
            <div
              class="d-none d-md-block d-lg-block"
              data-aos="fade-right"
            >
              <div class="crossed-line" />
            </div>

            <v-row
              data-aos="fade-lre"
              data-aos-offset="150"
            >
              <v-col
                :md="10"
                :offset-md="2"
              >
                <div class="text-3xl border border-default rounded-xl p-5 my-10  bg-white">
                  Você encontrará <span class="font-weight-bold">ebooks</span> com uma super revisão da teoria e
                  <span class="font-weight-bold">lista de questões</span> de 4 assuntos essenciais para potencializar seu desempenho
                  e alcançar uma nota ainda melhor no Enem.
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-divider
            class="mx-16"
            data-aos="fade-in"
          />
          <p
            class="text-xxl font-weight-bold text-center mb-2 p-0 mb-n2 text-uppercase mt-16"
            data-aos="fade-in"
            data-aos-delay="500"
          >
            Conteúdos para você
          </p>
          <p
            style="margin-left:40px; margin-right: 40px;"
            class="text-3xl text-center text-5xl mb-16 mt-4"
            data-aos="fade-in"
            data-aos-delay="600"
          >
            Sua lista personalizada contará com os <br> seguintes módulos:
          </p>
          <v-img
            v-for="(module, key) in authUser.modules"
            :key="module.id"
            :data-aos="key%2>0?'fade-right': 'fade-left'"
            class="img-container"
            max-height="300"
            :src="`/images/areas_do_conhecimento/${module.knowledge_area_id}.jpg`"
          >
            <v-layout
              align-center
              fill-height
            >
              <v-container>
                <v-row>
                  <v-col
                    md="5"
                    :offset-lg="key%2>0?7:0"
                    :offset-md="key%2>0?7:0"
                  >
                    <v-card>
                      <v-card-title class="bg-theme white--text font-weight-bold">
                        <span class="white--text">Módulo {{ key + 1 }}</span>
                      </v-card-title>
                      <v-card-text class="py-4">
                        <div class="rounded-lg bg-body p-3">
                          {{ module.name }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-layout>
          </v-img>
          <v-layout
            v-if="authUser.modules.length"
            justify-center
          >
            <div class="text-center p-5 m-5 dashed border-default">
              <p class="text-center text-4xl">
                Faça <span class="font-weight-bold">download</span>
                do seu caderno <br> personalizado e bons estudos
              </p>
              <div>
                <v-btn
                  color="nitro"
                  class="white--text"
                  :disabled="!authUser.files_processed"
                  @click="getFiles()"
                >
                  Baixar listas com capa
                </v-btn>
                <p
                  v-if="!authUser.files_processed"
                  class="text-danger text-center text-2xl"
                >
                  Aguarde, seus arquivos estão sendo processados.
                </p>
              </div>
            </div>
          </v-layout>
          <div v-else>
            <p
              class="text-center text-3xl text-danger mb-2"
              data-aos="fade-in"
              data-aos-delay="700"
            >
              Ainda não há módulos gerados para você.
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import AOS from "aos";

export default {
  data(){
    return { }
  },
  computed:{
    ...mapGetters(['authUser'])
  },
  mounted(){
      AOS.init({
        throttleDelay: 99,
        offset: 0,
        delay: 500,
        duration: 400,
        easing: 'ease-out-cubic',
        once: true,
        mirror: false,
        anchorPlacement: 'bottom',
      });

    if(!this.authUser){
      this.$router.push('login')
    }
  },
  methods:{
    ...mapActions(['isLoading']),
    getFiles(config = {book: false, cover:false, ebook: true, card:false}) {

        const token = `rZc7UfI5KI`

        let url = `https://cards.evolucional.com.br/web/api/${token}/nitro/concat`;

        const data = {
          "students_challenge_process" : {
            "production" : true,
            "cards": {
              "field_path": `pdfs/2023/${this.authUser.school.id}/${this.authUser.grade_id}/`,
              "card": false,
              "book": false,
              "cover": false,
              "ebook": true,
            },
            "sudents": [this.authUser.process_id],
          }
        }

        let myHeaders = new Headers();

        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: JSON.stringify(data),
          redirect: 'follow'
        };

        this.isLoading({ isLoading: true, message: 'Por favor, aguarde. Estamos processando sua solicitação.' });

        fetch(url, requestOptions)
        .then(response => response.text())
        .then(response => {
          const file = JSON.parse(JSON.parse(response).data).data;
          const url = 'https://cards.evolucional.com.br/web/' + file;
          window.open(url, '_blank')
        })
        .catch(() => this.$notify({
          type: 'error',
          text: 'Erro ao baixar arquivos'
        }))
          .finally(() => {
            this.is_loading_files = false
            this.isLoading({ isLoading: false, message: '' });
          })
      }
    },
  }
</script>
<style scoped lang="scss">
  .text-xxl {
    font-size: 5rem;
    line-height: 0.8em;
  }
  .text-greeting {
    display: inline;
    position: absolute;
    padding: 0 2.5rem;
    background: white;
  }

  .v-divider {
    border-width: revert !important;;
  }

  .border-default, .border{
    border-width: 2px!important;
    border-color: #e0e0e0;
  }

  .crossed-line {
    background-image: repeating-linear-gradient(15deg, #333333, #333333 8px, transparent 8px, transparent 24px, #333333 24px), repeating-linear-gradient(105deg, #333333, #333333 8px, transparent 8px, transparent 24px, #333333 24px), repeating-linear-gradient(195deg, #333333, #333333 8px, transparent 8px, transparent 24px, #333333 24px), repeating-linear-gradient(285deg, #333333, #333333 8px, transparent 8px, transparent 24px, #333333 24px);
    background-size: 3px calc(100% + 24.85px), calc(100% + 24.85px) 3px, 3px calc(100% + 24.85px) , calc(100% + 24.85px) 3px;
    background-position: 0 0, 0 0, 100% 0, 0 100%;
    background-repeat: no-repeat;
    height: 2px;
    z-index: -1;
    content: "";
    top:40px;
    transform: rotate(25deg);
    position: absolute;
    width: 371px;
    left: 300px;
    opacity: 0.4;
  }
  .dashed {
    background-image: repeating-linear-gradient(15deg, #8f8f8f, #8f8f8f 8px, transparent 8px, transparent 24px, #8f8f8f 24px), repeating-linear-gradient(105deg, #8f8f8f, #8f8f8f 8px, transparent 8px, transparent 24px, #8f8f8f 24px), repeating-linear-gradient(195deg, #8f8f8f, #8f8f8f 8px, transparent 8px, transparent 24px, #8f8f8f 24px), repeating-linear-gradient(285deg, #8f8f8f, #8f8f8f 8px, transparent 8px, transparent 24px, #8f8f8f 24px);
    background-size: 3px 100%, 100% 3px, 3px 100% , 100% 3px;
    background-position: 0 0, 0 0, 100% 0, 0 100%;
    background-repeat: no-repeat;
    border-radius: 10px;
    border-color: #e0e0e0;
  }
  .z-i-0 {
    z-index: 0;
  }
</style>
